import { useTranslation } from '@/hooks/useTranslation';
import type { PopupProps } from '@/types/component';
import { Button } from 'primereact/button';
import { useContext, useState, type RefObject } from 'react';
import { UserNotifPanel } from './components/UserNotifPanel/UserNotifPanel';
import { useCheckUserIsCustomer } from '@/hooks/useCheckUserIsCustomer';
import { IoGlobeOutline } from 'react-icons/io5';
import { TbLogout, TbMoon, TbSun } from 'react-icons/tb';
import { LayoutContext } from './context/context';
import ProfileMenu from '@/modules/global-components/ui/profile_menu';
import { useNavigate } from 'react-router';
import type { OverlayPanel } from 'primereact/overlaypanel';
import { LanguageMenu } from '@/modules/global-components/ui/LanguageMenu';
import { AnimatePresence, motion } from 'motion/react';
import { slideVariants } from '@/helpers/ComponentUtils';

export const MobileMenu = ({
  nr,
  tr,
  ar,
}: PopupProps & {
  nr: RefObject<OverlayPanel | null>;
  tr: RefObject<OverlayPanel | null>;
  ar: RefObject<OverlayPanel | null>;
}) => {
  const { t } = useTranslation('common');
  const nav = useNavigate();
  const { theme, toggleTheme } = useContext(LayoutContext);
  const [isOpenLangMenu, setIsOpenLangMenu] = useState(false);
  const { isUserCustomer } = useCheckUserIsCustomer();

  return (
    <div className="absolute right-0 top-full flex w-[200px] flex-col rounded-xl bg-surface-0 *:shadow-none">
      <Button
        type="button"
        onClick={() => {
          setIsOpenLangMenu(!isOpenLangMenu);
        }}
        severity="secondary"
        text
        className="flex gap-3"
      >
        <div className="size-5 shrink-0">
          <IoGlobeOutline className="size-full" />
        </div>
        {t('Language')}
      </Button>
      <AnimatePresence>
        {isOpenLangMenu && (
          <motion.div
            variants={slideVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <LanguageMenu isMobileMenu />
          </motion.div>
        )}
      </AnimatePresence>
      {!isUserCustomer && (
        <UserNotifPanel nr={nr} tr={tr} ar={ar} isMobileMenu />
      )}
      <Button
        type="button"
        onClick={toggleTheme}
        severity="secondary"
        text
        className="flex gap-3"
      >
        <div className="size-5 shrink-0">
          {theme === 'light' ? (
            <TbMoon className="size-full" />
          ) : (
            <TbSun className="size-full" />
          )}
        </div>
        {t('Switch Theme')}
      </Button>
      <ProfileMenu isMobileMenu />
      <Button
        type="button"
        onClick={() => {
          nav('/blank', {
            state: {
              type: 'logout',
            },
          });
        }}
        severity="secondary"
        text
        className="flex gap-3"
      >
        <div className="size-5 shrink-0">
          <TbLogout className="size-full" />
        </div>
        {t('Sign out')}
      </Button>
    </div>
  );
};
